import { render, staticRenderFns } from "./MsSiderBarBox.vue?vue&type=template&id=76d000b4&scoped=true"
import script from "./MsSiderBarBox.vue?vue&type=script&lang=js"
export * from "./MsSiderBarBox.vue?vue&type=script&lang=js"
import style0 from "./MsSiderBarBox.vue?vue&type=style&index=0&id=76d000b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d000b4",
  null
  
)

export default component.exports